import { render } from "./portnavbar.vue?vue&type=template&id=09918113&scoped=true"
import script from "./portnavbar.vue?vue&type=script&lang=js"
export * from "./portnavbar.vue?vue&type=script&lang=js"

import "./portnavbar.vue?vue&type=style&index=0&id=09918113&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09918113"]])

export default __exports__